declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

function trackEvent(eventName: string, params?: Record<string, any>) {
  if (window.gtag) {
    window.gtag("event", eventName, params);
  }
}

export function trackSignupCompleted() {
  trackEvent("signup_completed");
}

export function trackTrialActivated() {
  trackEvent("trial_activated");
}

export function trackStreamStarted(isFirst: boolean) {
  trackEvent("stream_started", { is_first: isFirst });
}

export function trackCheckoutInitiated() {
  trackEvent("checkout_initiated");
}

export function trackPaymentCompleted(liveStreamId: string) {
  trackEvent("payment_completed", { live_stream_id: liveStreamId });
}

// Acquisition keys forwarded to the API at signup (ops first-touch attribution).
const ACQUISITION_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "referrer",
  "landing_page",
];

export function captureUtmParams() {
  // First touch only: never overwrite an existing entry.
  if (localStorage.getItem("utm_params")) return;

  const params = new URLSearchParams(window.location.search);
  const utm: Record<string, string> = {};
  for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]) {
    const val = params.get(key);
    if (val) utm[key] = val;
  }
  const referrer = document.referrer || undefined;
  if (referrer) utm.referrer = referrer;
  utm.landing_page = window.location.pathname + window.location.search;

  localStorage.setItem("utm_params", JSON.stringify(utm));
}

// Stored first-touch fields filtered to the seven acquisition keys ({} when none).
export function getStoredAcquisition(): Record<string, string> {
  const stored = getStoredUtmParams();
  const out: Record<string, string> = {};
  if (!stored) return out;
  for (const key of ACQUISITION_KEYS) {
    const val = stored[key];
    if (typeof val === "string" && val) out[key] = val.slice(0, 500);
  }
  return out;
}

export function getStoredUtmParams(): Record<string, string> | null {
  const raw = localStorage.getItem("utm_params");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
